import { Utils } from '@genial/utils';

import { InputMoneyProps } from '../../../components/InputMoney';
import { AddedProductItemFundsProps } from '../components/Cart/components/AddedProductItem/Funds';
import { useFundsAssetController } from '../components/DynamicAsset/hooks/products/Funds';

import { useBatchTicketCartActionItem } from './batchTicketCartActionItem';

interface useFundAddedProductItemProps extends AddedProductItemFundsProps {}

export const useFundAddedProductItem = ({ data: item, type }: useFundAddedProductItemProps) => {
  const inputIsDisabled = type === 'requiredAttention';

  const { isLoadingAction, onRemoveProduct, onUpdateProduct } =
    useBatchTicketCartActionItem<'funds'>({
      item,
      id: 'funds',
      idSelector: 'productIdNormalized',
      type,
    });

  const {
    handleInputFocus,
    handleInputClear,
    isFocused,
    handleInputBlur,
    handleSubmit,
    control,
    hasError,
    helpText,
    currentValueFormatted,
  } = useFundsAssetController(item, onUpdateProduct);

  const minimumMovimentation = item.hasPosition
    ? item.applicationMinimumAmount
    : item.participateMinimumAmount;

  const minimumMovimentationFormatted = Utils.Mask.Money(minimumMovimentation);
  const isRequiredAttention = type === 'requiredAttention';
  const isTotalSummary = type === 'totalSummary';
  const useAmountValue = (isRequiredAttention || isTotalSummary) && item.amount;
  const currentValue = useAmountValue ? Utils.Mask.Money(item.amount) : currentValueFormatted;

  const inputMoneyDataProps = {
    id: `fund-product-added-applied-amount-${item.productId}`,
    name: 'createAppliedAmount',
    control,
    isDisabled: inputIsDisabled,
    currentValue,
    hasFocus: isFocused,
    minValue: item.applicationMinimumAmount,
    customInputProps: {
      ...(isFocused && hasError && { error: hasError }),
      ...(isFocused && !hasError && { helpText }),
    },
    handleFocus: handleInputFocus,
    handleBlur: handleInputBlur,
    handleSubmit,
    handleClear: handleInputClear,
  } as InputMoneyProps;

  return { inputMoneyDataProps, minimumMovimentationFormatted, onRemoveProduct, isLoadingAction };
};
